import React from "react";
import ReactDOM from "react-dom";

import NextApp from './NextApp';
// Service worker devre dışı bırakıldı - Güvenlik nedeniyle (bilgi ifşası riski)
// import registerServiceWorker from './registerServiceWorker';
// Add this import:
import {AppContainer} from 'react-hot-loader';
import "../src/routes/Akode/style.css"

// Wrap the rendering in a function:
const render = Component => {
  ReactDOM.render(
    // Wrap App inside AppContainer
    <AppContainer>
      <Component/>
    </AppContainer>,
    document.getElementById('root')
  );
};

// Service worker devre dışı - Güvenlik nedeniyle
// registerServiceWorker();

// Render once
render(NextApp);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./NextApp', () => {
    render(NextApp);
  });
}

